import { gSettings } from './Configuration';
import { longDateTime } from '../services/interfaces';
import { useContext } from 'react';
import { PageContext } from './PageContext';
import {DateTime} from "luxon";


export const makeLongDate=(longStr:string, locale:string)=>{

    //var locale="";
    gSettings().then(settings => locale=settings.Locale);

    const longDate:longDateTime = {
        year:longStr.substring(0,4),
        month:longStr.substring(4,6),
        day:longStr.substring(6,8),                    
    }
    const newDate=new Date(longDate.month+"/"+longDate.day+"/"+longDate.year);
    return newDate.toLocaleDateString(locale);
}

export const makeLongDateTime= (longDtStr:string)=>{
    gSettings().then(settings => {
        var locale=settings.Locale
        const longDateTime:longDateTime = {
            year:longDtStr.substring(0,4),
            month:longDtStr.substring(4,6),
            day:longDtStr.substring(6,8),
            hour:longDtStr.substring(8,10),
            minute:longDtStr.substring(10,12),
            second:longDtStr.substring(12,14),
        }
        console.log(longDateTime);
        const newDateTime=new Date(longDateTime.month+"/"+longDateTime.day+"/"+longDateTime.year +" "+ longDateTime.hour + ":" + longDateTime.minute + ":" + longDateTime.second);
        //const localDate = newDateTime.toLocaleTimeString(locale);
        return newDateTime;
    });
    return "";    
}

export async function makeShortDate(date:string){
    var retDate = "";
    var gSetting = await gSettings();
    var locale = gSetting.Locale;
    //    const newDate=new Date(date);
    //    console.log(newDate);
    //    retDate= newDate.toLocaleDateString(locale);
    //    console.log(retDate);
    //});
//    console.log(date);
    return date;
}

export const GetLongDateTime = (): string => {
    const pageContext=useContext(PageContext);
    const locale = pageContext?.glSettings.Locale;
    const now = new Date();
    return now.toLocaleString(locale).toUpperCase();
};

export const GetDateFromLong = (lngDate:number)=>{

}
                